//export const API_URL = 'http://localhost:8383/API_Vaga/public/api';
export const API_URL = 'https://api.vaga.amajnaric.eur.hr/public/api';